import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

export default function ChangePassword(props) {
  const { lang, proxy, functions } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const { profile } = props;
  const { replaceString } = functions;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const account = {
      username: profile.username,
      ...data,
    };

    fetch(`${proxy()}/auth/changePwd`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: _token,
      },
      body: JSON.stringify(account),
    })
      .then((res) => res.json())
      .then((res) => {
        const { data, success, content } = res;
        if (success) {
          reset();
        }
        Swal.fire({
          title: success ? lang["success"] : lang["error"],
          text: content,
          icon: success ? "success" : "error",
          showConfirmButton: !success ? true : false,
          timer: success && 1500,
        });
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mt-5 col-lg-8 col-xs-12">
        <div class="mb-3 row">
          <label class="col-lg-4 col-xs-12 control-label col-form-label font-weight-bold text-right infor_input">
            {lang["oldPass"]}
            <span className="red_star ml-1">*</span>
          </label>
          <div class="col-lg-8 col-xs-12">
            <input
              type="password"
              class="form-control"
              {...register("oldPassword", { required: true })}
            />
            {errors.oldPassword && (
              <p className="error-message">
                {replaceString(lang["required"], [lang["oldPass"]])}
              </p>
            )}
          </div>
        </div>
        <div class="mb-3 row ">
          <label
            for=""
            class="col-lg-4 col-xs-12 control-label col-form-label font-weight-bold text-right infor_input"
          >
            {lang["newPass"]}
            <span className="red_star ml-1">*</span>
          </label>
          <div class="col-lg-8 col-xs-12">
            <input
              type="password"
              class="form-control"
              id=""
              {...register("newPassword", { required: true })}
            />
            {errors.newPassword && (
              <p className="error-message">
                {replaceString(lang["required"], [lang["newPass"]])}
              </p>
            )}
          </div>
        </div>
        <div class="mb-3 row ">
          <label
            for=""
            class="col-lg-4 col-xs-12 control-label col-form-label font-weight-bold text-right infor_input"
          >
            {lang["confNewPass"]}
            <span className="red_star ml-1">*</span>
          </label>
          <div class="col-lg-8 col-xs-12">
            <input
              type="password"
              class="form-control"
              id=""
              {...register("confNewPassword", { required: true })}
            />
            {errors.confNewPassword && (
              <p className="error-message">
                {replaceString(lang["required"], [lang["confNewPass"]])}
              </p>
            )}
          </div>
        </div>
        <button type="submit" class="btn btn-success btn-custom float-right">
          {lang["changePass"]}
        </button>
      </div>
    </form>
  );
}
